import { type FC, useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'

//1000 * 60 * 60 * 24
const DAY_IN_MILLIS = 86_400_000
// 1000 * 60 * 60
const HOUR_IN_MILLIS = 3_600_000
// 1000 * 60
const MINUTE_IN_MILLIS = 60_000
const SECOND_IN_MILLIS = 1000
const TIMER_UPDATE_RATE = 1000

const getReturnValues = (
  countDown: number,
): [days: number, hours: number, minutes: number, seconds: number] => {
  // calculate time left
  const days = Math.floor(countDown / DAY_IN_MILLIS)
  const hours = Math.floor((countDown % DAY_IN_MILLIS) / HOUR_IN_MILLIS)
  const minutes = Math.floor((countDown % HOUR_IN_MILLIS) / MINUTE_IN_MILLIS)
  const seconds = Math.floor((countDown % MINUTE_IN_MILLIS) / SECOND_IN_MILLIS)

  return [days, hours, minutes, seconds]
}

const useCountdown = (
  fromData: Date | number | string,
): [days: number, hours: number, minutes: number, seconds: number] => {
  const countDownDate = new Date(fromData).getTime()

  const [countDown, setCountDown] = useState(countDownDate - Date.now())

  useEffect(() => {
    const interval = setInterval(() => {
      const dateNow = Date.now()

      if (countDownDate - dateNow < SECOND_IN_MILLIS) {
        clearInterval(interval)
      }

      setCountDown(countDownDate - dateNow)
    }, TIMER_UPDATE_RATE)

    return (): void => {
      clearInterval(interval)
    }
  }, [countDownDate])

  return getReturnValues(countDown)
}

export const StickyBannerCountdown: FC<{
  accentColor: string
  color: string
  endDate: string | Date
}> = ({ accentColor, color, endDate }) => {
  const [days, hours, minutes, seconds] = useCountdown(endDate)

  if (days + hours + minutes + seconds <= 0) {
    return null
  }

  return (
    <div className="flex flex-row gap-1.5 text-2xl font-bold" style={{ color }}>
      <div className="flex h-14 w-11 flex-col items-center justify-center rounded border">
        {days}
        <span className="text-xs font-medium">
          <FormattedMessage id="stickyBanner.coutdown.day" />
        </span>
      </div>
      <div className="flex h-14 w-11 flex-col items-center justify-center rounded border">
        {hours}
        <span className="text-xs font-medium">
          <FormattedMessage id="stickyBanner.coutdown.hour" />
        </span>
      </div>
      <div className="flex h-14 w-11 flex-col items-center justify-center rounded border">
        {minutes}
        <span className="text-xs font-medium">
          <FormattedMessage id="stickyBanner.coutdown.minute" />
        </span>
      </div>
      <div
        className="flex h-14 w-11 flex-col items-center justify-center rounded border"
        style={{ color: accentColor }}
      >
        {seconds}
        <span className="text-xs font-medium">
          <FormattedMessage id="stickyBanner.coutdown.second" />
        </span>
      </div>
    </div>
  )
}
